<span class="total_elements">{{getText()}}</span>
